import React from "react";
import { connect } from "react-redux";

const AddWidget = ({ _, setOpenModel }) => {
  const loadMoreTRData = () => {
    // load some more tr data.
  };

  return (
    <div className="container-fluid d-flex widget-details">
      <div className="col-3 add-widget-menu ">
        <div className="widget-header">
          <h2>Add Widgets</h2>
        </div>

        <div className="d-flex search-area">
          <div className="storage-search-input search-input input-group rounded-shadow ">
            <input
              id="searchTerm"
              type="text"
              className="form-control"
              placeholder="Search for widgets"
              value=""
            />
            <i className="icon-omni-search"></i>
          </div>
        </div>
        <div className="d-flex favourites">
          <i className="icon-omni-star-blue"></i>
          <h2>
            My Favourites (<span className="orange-number">5</span>){" "}
          </h2>
        </div>

        <div className="widget-buttons">
          <button
            className="d-flex justify-content-between styled-button "
            type="button"
            onClick={() => loadMoreTRData()}
          >
            Invoice Elements
            <i className="icon-omni-close-circle"></i>
          </button>
          <button
            className="d-flex justify-content-between styled-button "
            type="button"
            onClick={() => loadMoreTRData()}
          >
            Account Breakdown
            <i className="icon-omni-close-circle"></i>
          </button>
          <button
            className="d-flex justify-content-between styled-button "
            type="button"
            onClick={() => loadMoreTRData()}
          >
            Tabular Report
            <i className="icon-omni-close-circle"></i>
          </button>
          <button
            className="d-flex justify-content-between styled-button "
            type="button"
            onClick={() => loadMoreTRData()}
          >
            Favoured Item 1<i className="icon-omni-close-circle"></i>
          </button>
          <button
            className="d-flex justify-content-between styled-button "
            type="button"
            onClick={() => loadMoreTRData()}
          >
            Upload File Widget
            <i className="icon-omni-close-circle"></i>
          </button>
        </div>
      </div>
      <div className="col-9 widget-information">
        <button
          className="btn btn-close-modal float-right"
          onClick={() => setOpenModel(false)}
        >
          <i className="icon-omni-close-circle " />
        </button>
        <div className="container-fluid widget-info">
          <div className="row">
            <div className="col-2 graph-images">
              <div className="d-flex align-items-center justify-content-center graphic-carts">
                <div className="d-flex justify-content-center graphic-carts-image">
                  <i className="icon-omni-document"></i>
                </div>
              </div>
            </div>
            <div className="col-7 graph-details">
              <h2>Invoice Elements Breakdown</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
            <div className="d-flex col-3 graph-widgets">
              <div>
                <button
                  className="d-flex justify-content-between button "
                  type="button"
                  onClick={() => loadMoreTRData()}
                >
                  <i className="icon-omni-favourite-true"></i>
                </button>
              </div>
              <div></div>
              <button
                className="d-flex justify-content-center styled-button "
                type="button"
                onClick={() => loadMoreTRData()}
              >
                Remove this Widget
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-2 graph-images">
              <div className="d-flex align-items-center justify-content-center graphic-carts">
                <div className="d-flex justify-content-center graphic-carts-image">
                  <i className="icon-omni-document"></i>
                </div>
              </div>
            </div>
            <div className="col-7 graph-details">
              <h2>Invoice Elements Breakdown</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
            <div className="d-flex col-3 graph-widgets-2">
              <div>
                <button
                  className="d-flex justify-content-between button "
                  type="button"
                  onClick={() => loadMoreTRData()}
                >
                  <i className="icon-omni-star-blue"></i>
                </button>
              </div>
              <div></div>
              <button
                className="d-flex justify-content-center styled-button "
                type="button"
                onClick={() => loadMoreTRData()}
              >
                Add this Widget
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-2 graph-images">
              <div className="d-flex align-items-center justify-content-center graphic-carts">
                <div className="d-flex justify-content-center graphic-carts-image">
                  <i className="icon-omni-document"></i>
                </div>
              </div>
            </div>
            <div className="col-7 graph-details">
              <h2>Invoice Elements Breakdown</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
            <div className="d-flex col-3 graph-widgets-2">
              <div>
                <button
                  className="d-flex justify-content-between button "
                  type="button"
                  onClick={() => loadMoreTRData()}
                >
                  <i className="icon-omni-star-blue"></i>
                </button>
              </div>
              <div></div>
              <button
                className="d-flex justify-content-center styled-button "
                type="button"
                onClick={() => loadMoreTRData()}
              >
                Add this Widget
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-2 graph-images">
              <div className="d-flex align-items-center justify-content-center graphic-carts">
                <div className="d-flex justify-content-center graphic-carts-image">
                  <i className="icon-omni-document"></i>
                </div>
              </div>
            </div>
            <div className="col-7 graph-details">
              <h2>Invoice Elements Breakdown</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
            <div className="d-flex col-3 graph-widgets-2">
              <div>
                <button
                  className="d-flex justify-content-between button "
                  type="button"
                  onClick={() => loadMoreTRData()}
                >
                  <i className="icon-omni-star-blue"></i>
                </button>
              </div>
              <div></div>
              <button
                className="d-flex justify-content-center styled-button "
                type="button"
                onClick={() => loadMoreTRData()}
              >
                Add this Widget
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const mapStateToProps = ({ _ }) => ({ _ });

export default connect(mapStateToProps)(AddWidget);
